import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class DesignerSelectDimensionTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__SELECT_DIMENSION;
	override trackEvent: TrackingEvent | '' = TrackingEvent.DIMENSION_SELECT;

	get id(): string {
		return TourId.DESIGNER__SELECT_DIMENSION;
	}

	override get keyForPersistantDone(): string {
		return DesignerSelectDimensionTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.LEFT,
				allowStacked: true,
				attachTo: () => {
					return $('.designer-panel--right .bs__metric--open .bs__dimensions .select2');
				},
				doAction: () => {
					this.end();
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
